<template>
  <div class="PaB-cart-item" v-if="product">
    <header class="PaB-cart-item__header" v-if="widgetOptions.style.product_images">
      <div class="PaB-cart-item__media">
        <img :src="product.product_image.sm" :alt="product.name" :title="product.name" v-if="!product.product_image.is_default">
      </div>
    </header>

    <div class="PaB-cart-item__body">
      <div class="PaB-cart-item__details">
        <h4 class="PaB-cart-item__title">{{ cartItem.product_name }}</h4>
        <p class="PaB-cart-item__vendor">Vendor: {{ cartItem.product_brand }}</p>
        <div class="PaB-cart-item__offer">
          <quantity v-model="cartItem.quantity" :value="cartItem.quantity" v-if="editable" />
          <span class="PaB-cart-item__price">
            <pretty-money :amt="cartItem.price | currency({cents: true, whole_dollars: true})" /><span class="PaB-combine-weights"
              v-if="product.combine_weights">/{{ cartItem.weight }}</span></span>
        </div>
      </div>
      <button @click="removeItem" class="remove-PaB-cart-item" v-if="editable">
        <icon-base icon-name="Remove item" width="15" height="15">
          <icon-close />
        </icon-base>
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.PaB-cart-item {
  display: flex;
  flex-direction: row;
  position: relative;
  padding: 8px;
  border: 1px solid rgba(#7f7f7f, 0.2);
  background-color: #fff;

  &__header {
    flex: 0 0 70px;
    margin-right: 12px;
    display: none;
    @media screen and (min-width: 440px) {
      display: block;
    }
  }

  &__title {
    margin-bottom: 0;
    font-size: 18px;
    font-weight: bold;
    margin-right: 40px;
  }

  &__vendor {
    margin: 5px 0;
  }

  &__offer {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .PaB-quantity {
      width: 132px;
      margin-right: 0.5em;
    }
    .PaB-cart-item__price {
      font-size: 18px;
      margin: 0;
    }
  }

  &__media {
    img {
      width: 100%;
    }
  }

  .remove-PaB-cart-item {
    width: 40px;
    height: 40px;
    color: currentColor !important;
    position: absolute;
    top: 0;
    right: 0;
    padding: 8px;
    border: 0;
    background-color: transparent;
    -webkit-appearance: none;
  }
}
</style>

<script>
import Quantity from '@/components/Quantity'
import IconBase from '@/components/IconBase'
import IconClose from '@/components/icons/IconClose'

export default {
  components: {
    Quantity,
    IconBase,
    IconClose
  },
  props: {
    cartItem: {
      type: Object
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    product () {
      return this.$store.getters['products/findProduct'](this.cartItem.product_parent_id)
    }
  },
  methods: {
    removeItem () {
      this.$store.dispatch('cart/removeItemFromCart', { id: this.cartItem.product_id, parent_id: this.cartItem.product_parent_id })
    }
  },
  created () {
    this.$watch('cartItem.quantity', (newValue, oldValue) => {
      if (newValue !== oldValue) {
        this.$store.dispatch('cart/updateItemQuantity', { product_id: this.cartItem.product_id, quantity: newValue })
      }
    }, { deep: true })
  },
  mounted () {
    if (this.product === false) {
      this.removeItem()
    }
  }
}
</script>
